import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { MetaPlanEvents } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/meta-plan-events")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <MetaPlanEvents />
    </RouteGuard>
  ),
});
